// /admin/orgs/:orgSlug — one tenant, from the operator's side.
//
// NOT /dashboard/:orgSlug: that is the tenant's own workspace and is org-gated.
// This is the operator looking at a tenant they are not a member of.

import { createRoute } from "@tanstack/react-router";
import { adminRoute } from "./_admin";
import { TenantDetailScreen } from "../screens/admin/TenantDetailScreen";

export const adminTenantRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/admin/orgs/$orgSlug",
  staticData: { title: "Tenant" },
  component: AdminTenantRoute,
});

function AdminTenantRoute() {
  const { orgSlug } = adminTenantRoute.useParams();
  return <TenantDetailScreen orgSlug={orgSlug} />;
}
